import type React from 'react'
import { BottomDock, Button, CardContainer } from '@stone-payments/jade'

import styles from './styles.module.css'

type KycStatusContainerProps = {
  children: React.ReactNode | React.ReactNode[]
  actionButton?: () => void
}

export const KycStatusContainer = ({ children, actionButton }: KycStatusContainerProps) => {
  return (
    <CardContainer className={styles['card-container']}>
      <div className="p-5">{children}</div>
      {actionButton ? (
        <BottomDock className={styles['bottom-dock']}>
          <Button icon="action-logout" onClick={actionButton}>
            Sair
          </Button>
        </BottomDock>
      ) : null}
    </CardContainer>
  )
}
